module.exports = __webpack_public_path__ + "img/office-purple.2a2305b2.png";